import React from 'react';
import { formatScore } from '../calculator/calculator';

interface YourScoresProps {
  currentScore: number;
  highestAttainableScore?: number; // Maximum possible score for the programme
  translate: any;
}

export const YourScores: React.FC<YourScoresProps> = ({
  currentScore,
  highestAttainableScore,
  translate
}) => {
  return (
    <div className="p-2 bg-blue-50 rounded-lg">
      <div className="flex items-center gap-2">
        <h4 className="font-semibold text-blue-600 text-xs whitespace-nowrap">
          {translate('yourScores')}
        </h4>

        <div className="flex gap-1 flex-1">
          <div className="rounded-lg px-2 py-1 text-center border-2 border-transparent bg-yellow-50 flex-1">
            <span className="text-xs font-normal text-gray-600">
              {translate('currentScore')}{' '}
            </span>
            <span className="text-sm font-bold text-yellow-600">
              {formatScore(currentScore)}
              {highestAttainableScore && highestAttainableScore > 0 && (
                <span className="text-xs font-normal ml-1 text-gray-500">
                  / {formatScore(highestAttainableScore)}
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
